import _lib from '../_lib';
import active from './active/index';
import {CptNavigation} from '@/store/modules/fsm/messages';

export default ({tree,parent,api}) => {
  let regionName = 'cpt';
  let activations = [
    {
      name: 'cpt',
      test: api.messageIs(CptNavigation)
    }
  ];
  let activeIndex = active;
  let func = _lib({regionName,activations,activeIndex});
  return func({tree,parent,api});
};